var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(" DATASOURCES ")]),_c('cbs-object',{attrs:{"objectid":11},on:{"close":_vm.closeCard}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }